// @ts-strict-ignore
import {EventDefinition} from 'common/util/definitions-types';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {apiClient} from 'common/util/api-client';
import {getProjectId, getWorkspaceId} from 'common/report/util';
import {getLocation} from 'common/util/url';

import {appApiUrl} from '../utils';
import {purgeFetchCache} from '../utils/fetch-cache';

function buildEndpoint() {
  return appApiUrl(`data-definitions/events`, {projectId: getProjectId(), workspaceId: getWorkspaceId()});
}

async function fetchEventDefinitions(fromFetchCache: boolean): Promise<{[key: string]: EventDefinition}> {
  // eslint-disable-next-line local-rules/deprecated-member-access
  const result = await apiClient.fetch(buildEndpoint(), {
    headers: {
      'Request-URL': getLocation().href,
    },
    method: `GET`,
    fromFetchCache,
  });
  const eventDefinitions: EventDefinition[] = (await result?.json())?.results ?? [];
  // If this is from cache, and it's empty, return null instead of an empty set.
  // Otherwise, ApiResource will signal that the index fetch is done, when it really isn't
  if (!eventDefinitions.length && fromFetchCache) {
    return null;
  }
  return eventDefinitions.reduce((acc, eventDefinition) => {
    acc[eventDefinition.name] = eventDefinition;
    return acc;
  }, {});
}

export async function update(updatePayload: Partial<EventDefinition>): Promise<EventDefinition> {
  return apiClient.patch<EventDefinition>(buildEndpoint(), {
    ...updatePayload,
  });
}

export async function bulkUpdate(eventDefUpdates: Array<Partial<EventDefinition>>) {
  return apiClient.patch<EventDefinition[]>(buildEndpoint(), {events: eventDefUpdates});
}

export const eventDefinitionsClient: ApiResourceClient<EventDefinition> = {
  index() {
    return {
      cache: fetchEventDefinitions(true),
      network: fetchEventDefinitions(false),
    };
  },

  get() {
    throw new Error(`Getting a single event definitions is not supported`);
  },

  purgeCache() {
    purgeFetchCache({everything: true, path: buildEndpoint()});
  },
};
